<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="450px"
      v-bind:body-style="{ height: '300px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm" style="height: 50px;">
        <a-row >
          <a-col :span = "24">
            <a-form-model-item label="业务员:" prop="busUserId">
              <a-input v-model="searchList.userName" placeholder="请输入关键字" @focus="getTableData()" @change="getTableData()" @blur="close"/>
              <div  v-if="show" class="search">
                <a-table
                  v-if="show"
                  class="antd-table"
                  :row-selection="{type:'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange , columnWidth: '50px'}"
                  bordered
                  :columns="relevanceBatch_grid.field"
                  :data-source="relevanceBatch_grid.row"
                  :rowKey="(record, index) => { return record.id;}"
                  size="small"
                  :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
                  :pagination="false"
                  :loading="tableLoading"
                  style="padding: 10px;"
                >
                <!-- 序号 -->
                <span slot="index" slot-scope="text, record, index">
                  {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
                </span>
              </a-table>
              <!-- 底部 -->
              <div class="table_bottom">
                <!-- 分页 -->
                <div>
                  <a-pagination
                    class="table_pagination"
                    show-size-changer
                    :default-current="1"
                    v-model="pageParam.pageNum"
                    :show-total="(total) => `共 ${total} 条`"
                    :page-size-options="pageSizeOptions"
                    size="small"
                    :total="total"
                    @showSizeChange="onShowSizeChange"
                    @change="paginationChange"
                    :page-size.sync="pageParam.pageSize"
                  />
                </div>
              </div>
            </div>
          </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="交付说明:" prop="serviceRemark">
              <a-textarea :rows="4" v-model="searchList.serviceRemark" :allowClear="true" placeholder="请输入交付说明"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="cancel-color" ghost @click="handleCancel">取消</a-button>
      <a-button  class="btn-color" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import{ queryEmp,addProgressDisp } from "@/api/api.js";
export default {
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    data: {
      type: Object,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      visible: true,
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      okLoad: false,
      empList:[],//员工信息
      //绑定值
      searchList: {
        id: "",
        busUserId: "",
        userName:"",
        serviceRemark:""
      },

      //校验规则
      rules: {
        busUserId: [
          {
            required: true,
            message: "请选择业务员",
            trigger: "change",
          }
        ],
        serviceRemark: [
          {
            max: 400,
            message: "不可超过400字",
            trigger: "blur",
          },
        ],
      },
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
        {
            title: "序号",
            align: "center",
            width: 45,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "用户名",
            align: "center",
            width: 170,
            dataIndex: "userName",
            ellipsis: true,
          },
          {
            title: "用户账号",
            align: "center",
            width: 160,
            dataIndex: "userCode",
            ellipsis: true,
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      selectedRowKeys: [],
      //查询加载
      tableLoading:false,
      show:false
    }
  },
  mounted() {
    this.searchList.id = this.data.id;
  },
  methods: {
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.getTableData();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.getTableData();
    },
    onSelectChange(data, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = data;
      this.searchList.userName = this.selectedRows[0].userName;
      this.searchList.busUserId = data[0];
      this.show = false;
    },
    //获取表格信息
    getTableData(){
      this.selectedRows=[];
      this.selectedRowKeys =[];
      this.tableLoading = true;
      this.show = true;
      if (this.searchList.userName != null && this.searchList.userName != '' && this.searchList.userName != undefined) {
        this.pageParam.pageNum = 1;
        queryEmp({
          pageParam: {
              pageNum: this.pageParam.pageNum,
              pageSize: this.pageParam.pageSize,
              orderBy: ""
            },
            content: {
              empName: this.searchList.userName
            }
          }).then(
          (res) => {
            if (res.content.rows && res.content.rows.length) {
              this.relevanceBatch_grid.row = res.content.rows;
              this.total = res.content.page.totalRows;
            } else {
              this.relevanceBatch_grid.row = [];
              this.total = 0;
            }
            this.tableLoading = false;
          },
          (err) => {
            this.tableLoading = false;
            this.$message.error('查询员工信息失败')
          }
        )
      } else {
        queryEmp({
          pageParam: {
              pageNum: this.pageParam.pageNum,
              pageSize: this.pageParam.pageSize,
              orderBy: ""
            },
            content: {
              empName: this.searchList.userName
            }
          }).then(
          (res) => {
            if (res.content.rows && res.content.rows.length) {
              this.relevanceBatch_grid.row = res.content.rows;
              this.total = res.content.page.totalRows;
            } else {
              this.relevanceBatch_grid.row = [];
              this.total = 0;
            }
            this.tableLoading = false;
          },
          (err) => {
            this.tableLoading = false;
            this.$message.error('查询员工信息失败')
          }
        )
      }
    },
    //失去交焦点--延迟
    close(event){
      setTimeout(() => {
        if(event.relatedTarget._prevClass == "ant-modal-wrap "){
          this.show = false;
        }
      }, 100)
    },

    //取消
    handleCancel() {
      this.searchList = [];
      //关闭弹窗
      this.$emit("close");
    },

    //派单
    handleOk() {
      if(this.searchList.userName == "" || this.searchList.userName == null || this.searchList.userName == undefined){
        this.searchList.busUserId = "";
      }
      let paramObj={
        id:this.searchList.id,
        recNo:this.data.recNo,
        recStatus:'1',//服务中
        busUserId:this.searchList.busUserId,
        serviceRemark:this.searchList.serviceRemark
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.okLoad = true
          addProgressDisp(paramObj).then(
              (res) => {
                if (res.code == '0000') {
                  this.okLoad = false;
                  this.$message.success('派单成功');
                  this.$emit('handleOk');
                }
              },
              (err) => {
                this.okLoad = false
              }
            )
        };
      })
    },
  },
}
</script>

<style lang="less" scoped>
.btn-color {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}
.cancel-color{
  border-color: rgba(22, 130, 139, 1);
  color: rgba(22, 130, 139, 1);
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}

/deep/ .ant-pagination {
    justify-content: right;
    display: flex;
    margin-top: 10px;
}
.table_bottom{
  height: 35px;
}
.search{
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
  width: 500px;
  max-height: 300px; 
  background-color: #fff; 
  z-index: 2; 
  position: absolute;
}
/deep/ .ant-table-wrapper {
    zoom: 1;
    max-height: 240px;
}
/deep/ .ant-table-scroll {
    max-height: 226px;
    overflow: hidden;
}
/deep/ .ant-table-small.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
  max-height: 190px !important;
}
</style>
